import(/* webpackMode: "eager" */ "/home/buyme/htdocs/buyme.lk/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyAd"] */ "/home/buyme/htdocs/buyme.lk/src/components/ThirdPartyAd.tsx");
